import type { SVGProps } from 'react';
const SvgFilter7 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#filter_7_svg__a)">
      <path
        fill="currentColor"
        d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5Zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2Zm0 16H7V3h14v14Zm-8-2 4-8V5h-6v2h4l-4 8h2Z"
      />
    </g>
    <defs>
      <clipPath id="filter_7_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFilter7;
